export const getElementIdFromNode = (value: string) => `radio-${value}`
